/**
 * シフト時刻表示ユーティリティ
 *
 * 旧 /api/doctor-shifts 系は start_time / end_time を
 * 「2026/07/01 09:00:00」(一覧) や「2026-07-01T09:00:00.000000Z」(詳細) の
 * 日付付き文字列で返す（旧仕様互換で凍結）。画面では時刻のみを表示する。
 */

/**
 * 時刻文字列から HH:mm を取り出す。
 *
 * 対応形式: "2026/07/01 09:00:00" / "2026-07-01T09:00:00.000000Z" /
 * "09:00:00" / "9:00"。時刻が見つからない場合は入力をそのまま返す。
 * タイムゾーン変換は行わない（保存値は現地時刻のため文字列のまま抽出する）。
 */
export const extractTimeHm = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }

  // 日付部分にはコロンが含まれないため、最初の「H:MM」ペアが時刻
  const match = value.match(/(\d{1,2}):(\d{2})/);
  if (!match) {
    return value;
  }

  return `${match[1].padStart(2, '0')}:${match[2]}`;
};
